import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {GridOptions} from 'ag-grid';
import { anchorPopupToSource } from '../../../core/helpers/ag-grid-popup.util';
import {ReservationService} from '../reservations.service';
import {T2CardComponent} from '../../../trip2-theme/components/t2-card/t2-card.component';
import {BooleanCheckComponent} from '../../A2-utils/grid-components/boolean-check/boolean-check.component';
import * as moment from "moment";
import {ParentModule} from "../../A2-utils/ParentClass/parent-module";
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-standing-order-history',
  templateUrl: './standing-order-history.component.html',
  styleUrls: ['./standing-order-history.component.scss']
})
export class StandingOrderHistoryComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
    riderid: number;
    @Input() denial = false;
    @Output() standingOrderID: EventEmitter<number> = new EventEmitter<number>();
    @Output() newStandingOrder: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() copyStandingOrder = new EventEmitter<any>();
    @Input() updateGrid?: any;
    @Output() reloadTrips? = new EventEmitter<any>();
    modelDatePicker: any;

    private disabledStatusChange_SO_btn = true;
    disableCopySO = true;
    private so_id: number;
    private selecteSO_ID: number;
    private tripCancelReasonId: number;
    private tripStatusId: number;
    protected grid: GridOptions;
    protected showCancelStatus = false;
    protected showCancelSO = false;
    protected showCopySO = false;
    @ViewChild('popStatus') popStatus: T2CardComponent;
    suscriptors$: Subscription[] = [];
    private beginDate: any;
    private endDate: any;

  constructor(
    protected service: ReservationService,
    private Inject: Injector
  ) {
      super('app-edit-reservation-form', Inject);
      this.grid = <GridOptions>{};
      this.grid.enableColResize = true;
      this.grid.enableSorting = true;
      this.configureGrid();
      this.suscriptors$.push(
      this.service.riderSelected$.subscribe(rider => {
        this.riderid =  rider;
       this.getStandingOrder(rider);
      }),
        this.service.reloadTrips$.subscribe(() =>
        this.getStandingOrder(this.riderid))
      );
  }

  get showCancelSOButton(): boolean {
    return !this.denial && this.showCancelSO;
  }

  get showCopySOButton(): boolean {
    return !this.denial && this.showCopySO;
  }

  ngOnInit() {
    this.subscribeToActions();
  }

  private subscribeToActions(): void {
    this.suscriptors$.push(
      this.actionsList$.subscribe((resp) => {
        if (resp && resp.length) {
          this.showCancelSO = resp.includes('Show Cancel SO');
          this.showCopySO = resp.includes('Show Copy SO');
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.suscriptors$.forEach((item) => item.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  /**
     * @description
     * @param riderid
     */
      public getStandingOrder(riderid) {
          this.riderid = riderid;
          this.service.getStandingOrder(this.riderid).subscribe(
              data => {
                if (this.grid) {
                  if (this.grid.api) {
                    this.grid.api.setRowData(data);
                    this.grid.api.refreshView();
                  }
                }
              }
          );
      }
    /**
     * @description
     */
    private configureGrid() {
        const resize = this.grid;
        this.grid.postProcessPopup = (params) => {
          if (params && params.ePopup) {
            anchorPopupToSource(
              params.ePopup as HTMLElement,
              params.eventSource as HTMLElement,
            );
          }
        };
        this.grid.columnDefs = [
            {
                headerName: 'SO Id',
                field: 'standingorderid',
                width: 50
            },
            {
                headerName: 'SO Date',
                field: 'addedon',
                width: 80,
                cellRenderer: function (params) {
                    const dateFormated = params.value;
                    const splitDate = dateFormated.split('T');
                    const dateFormatted = splitDate[0].split('-');
                    const dataShow = dateFormatted[1] + '-' + dateFormatted[2] + '-' + dateFormatted[0];
                    return dataShow;
                }
            },
            {
                headerName: 'Start Date',
                field: 'fromdate',
                colId: 'fromdate',
                width: 80,
                cellRenderer: function (params) {
                    const dateFormated = params.value;
                    const splitDate = dateFormated.split('T');
                    const dateFormatted = splitDate[0].split('-');
                    const dataShow = dateFormatted[1] + '-' + dateFormatted[2] + '-' + dateFormatted[0];
                    return dataShow;
                }
            },
            {
                headerName: 'End Date',
                field: 'todate',
                colId: 'todate',
                width: 80,
                cellRenderer: function (params) {
                    const dateFormated = params.value;
                    const splitDate = dateFormated.split('T');
                    const dateFormatted = splitDate[0].split('-');
                    const dataShow = dateFormatted[1] + '-' + dateFormatted[2] + '-' + dateFormatted[0];
                    return dataShow;
                }
            },
            {
                headerName: 'Pick Up',
                field: 'pickup',
                colId: 'pickup',
                width: 100,
            },
            {
                headerName: 'Drop Off',
                field: 'dropoff',
                colId: 'dropoff',
                width: 100,
            },
            {
              headerName: 'Status',
              field: 'standingorderstatus.description',
              colId: 'status',
              width: 100,
            },
            {
                headerName: 'Mo',
                field: 'monday',
                colId: 'monday',
                width: 50,
                cellRendererFramework: BooleanCheckComponent
            },
            {
                headerName: 'Tu',
                field: 'tuesday',
                colId: 'tuesday',
                width: 50,
                cellRendererFramework: BooleanCheckComponent
            },
            {
                headerName: 'We',
                field: 'wednesday',
                colId: 'wednesday',
                width: 50,
                cellRendererFramework: BooleanCheckComponent
            },
            {
                headerName: 'Th',
                field: 'thursday',
                colId: 'thursday',
                width: 50,
                cellRendererFramework: BooleanCheckComponent
            },
            {
                headerName: 'Fr',
                field: 'friday',
                colId: 'friday',
                width: 50,
                cellRendererFramework: BooleanCheckComponent
            },
            {
                headerName: 'Sa',
                field: 'saturday',
                colId: 'saturday',
                width: 50,
                cellRendererFramework: BooleanCheckComponent
            },
            {
                headerName: 'Su',
                field: 'sunday',
                colId: 'sunday',
                width: 50,
                cellRendererFramework: BooleanCheckComponent
            }
        ];

        this.grid.onGridReady = function () {
            resize.api.sizeColumnsToFit();
        };
    }
    /**
     * @description
     * @param event
     */
    public onRowDoubleClicked(event) {
        this.standingOrderID.emit(event.data.standingorderid);
    }

    /**
     * @description
     * @param event
     */
    public onRowCellClicked(event) {
        this.disabledStatusChange_SO_btn = event.data.standingorderstatusid === 1 ? false : true;
        this.disableCopySO = false;
        this.so_id                = event.data.standingorderid;
        this.selecteSO_ID         = event.data.standingorderid;
        this.tripCancelReasonId   = event.data.tripcancelreasonid;
        this.tripStatusId         = event.data.tripstatusid;
        this.beginDate            = event.data.startdate;
        this.endDate              = event.data.enddate;
        event.node.setSelected(true);

        if(this.isAllowedAction('Allow So Changes By Date')) {
          this.assignDateToDatePicker(event.data.startdate, event.data.enddate);
        }
    }

    /**
     * this emit copy SO
     */
    copySO() {
        this.copyStandingOrder.emit(this.so_id);
    }

    /**
     * @description
     */
    public onReloadGridEmmited() {
        this.getStandingOrder(this.riderid);
        this.reloadTrips.emit(this.riderid);
    }

    /**
     * @description
     */
    public clickNewStantingOrder() {
        this.newStandingOrder.emit(true);
    }

    assignDateToDatePicker(begin, end) {
      begin = moment(begin,"MM/DD/YYYY");
      end = moment(end,"MM/DD/YYYY");

      this.modelDatePicker = {
        beginDate: {
          year: begin.year(),
          month: begin.month() + 1,
          day: begin.date(),
        },
        endDate: {
          year: end.year(),
          month: end.month() + 1,
          day: end.date(),
        }
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/standing-order-history/standing-order-history.component.ts